export default __webpack_public_path__ + "static/media/hrms-product.e090a35d.svg";